import React from 'react';
import styled from 'styled-components';
import { FaHome, FaBuilding } from 'react-icons/fa';
import { colors } from '../../../assets/styles/GlobalStyles';

// Cabeçalho padronizado (ícone + título + descrição) para as seções de
// endereço residencial/comercial.

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1.5rem;
  padding-bottom: 0.8rem;
  border-bottom: 2px solid ${colors.lightBlue};
`;

const Icon = styled.div`
  color: ${colors.darkBlue};
  font-size: 1.2rem;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${colors.darkBlue};
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.3rem;
`;

/**
 * @param {string} props.type - Tipo do endereço ('residencial' ou 'comercial')
 */
export const AddressHeader = ({ type }) => {
  const config = {
    residencial: {
      Icon: FaHome,
      title: 'Endereço Residencial',
      description: 'Endereço principal de residência'
    },
    comercial: {
      Icon: FaBuilding,
      title: 'Endereço Comercial',
      description: 'Endereço comercial (opcional)'
    }
  };

  const { Icon: IconComponent, title, description } = config[type];

  return (
    <Header>
      <Icon>
        <IconComponent />
      </Icon>

      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </div>
    </Header>
  );
};
